import { api, attachApiToken } from "./config";
import {
  GET_USERS,
  SIGN_UP,
  SIGN_IN,
  UPDATE_ITEM_INVENTORY,
  UPDATE_PROFILE,
  FORGET_PASSWORD_USER,
  GET_A_USER,
  DELETE_USER,
  GET_ONE_STORE,
  GET_ALL_STORES,
  CREATE_STORE,
  VALIDATE_SINGLE_STORE,
  LOGIN_STORE,
  ADD_STORE_INVENTORY,
  STORE_FORGOT_PASSWORD,
  STORE_RESET_PASSWORD,
  USER_RESET_PASSWORD,
  DELETE_STORE,
  VERIFY_EMAIL
} from "./api";

/**
 * @param password - User Password
 * @param email - User email
 * ===============================
 * LOGIN REQUEST IS MADE HERE
 * ===============================
 */

export function loginCall(data) {
  return api.post(SIGN_IN, data);
}

/**
 * @param surname - User Surname
 * @param firstname - User email
 * @param password - password
 * @param username - username
 * @param confirm_password - confirm_password
 * @param email - email@gmail.com
 * @param fields - GIS
 * @param phonenumber - phonenumber
 * ===============================
 * REGISTER REQUEST IS MADE HERE
 * ===============================
 */

export function registerCall(data) {
  return api.post(SIGN_UP, data);
}

export async function getUsersCall() {
  const apiCall = await attachApiToken(api);
  return apiCall.get(GET_USERS);
}

export async function getAUserCall() {
  const apiCall = await attachApiToken(api);
  return apiCall.get(GET_A_USER);
}

export async function updateProfileCall(data) {
  const apiCall = await attachApiToken(api);
  return apiCall.put(UPDATE_PROFILE, data);
}

export async function forgetPasswordCall(data) {
  return api.post(FORGET_PASSWORD_USER, data);
}

export async function deleteUserCall(data) {
  const apiCall = await attachApiToken(api);
  return apiCall.delete(DELETE_USER, data);
}

export async function getOneStoreCall(data, storeName) {
  const apiCall = await attachApiToken(api);
  return apiCall.get(GET_ONE_STORE(storeName), data);
}

export async function getAllStoresCall() {
  const apiCall = await attachApiToken(api);
  return apiCall.get(GET_ALL_STORES);
}

export async function createStoreCall(data) {
  const apiCall = await attachApiToken(api);
  return apiCall.post(CREATE_STORE, data);
}

export async function validateSingleStoreCall(data, email) {
  const apiCall = await attachApiToken(api);
  return apiCall.delete(VALIDATE_SINGLE_STORE(email), data);
}

export function loginStoreCall(data) {
  return api.post(LOGIN_STORE, data);
}

export async function addStoreInventoryCall(data, id) {
  const apiCall = await attachApiToken(api);
  return apiCall.post(ADD_STORE_INVENTORY(id), data);
}

export async function updateItemInventoryCall(data, id, itemName) {
  const apiCall = await attachApiToken(api);
  return apiCall.put(UPDATE_ITEM_INVENTORY(id, itemName), data);
}

export async function storeForgotPasswordCall(data) {
  return api.post(STORE_FORGOT_PASSWORD, data);
}

export async function storeResetPasswordCall(id, token, data) {
  return api.post(STORE_RESET_PASSWORD(id, token), data);
}

export async function userResetPasswordCall(id, token, data) {
  return api.post(USER_RESET_PASSWORD(id, token), data);
}

export async function deleteStoreCall(data) {
  const apiCall = await attachApiToken(api);
  return apiCall.delete(DELETE_STORE, data);
}

//THIS IS TO VERIFY THE EMAIL

export async function verifyEmailCall(token) {
  const apiCall = await attachApiToken(api);
  return apiCall.get(VERIFY_EMAIL(token))
}